import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
const db = firebase.firestore();

export type User = {
  name: string
  admin: boolean
  email: string
  phone: string
  cnpj: string
  corporate: string
  id: number
  uid: string
  studiesCount?: number;
};

type StudiesState = {
	isLoading: boolean,
	error: Error | string | null;
	users: Array<User>;
};

const initialState: StudiesState = {
	isLoading: false,
	error: null,
	users: [],
};

const slice = createSlice({
	name: 'studies',
	initialState,
	reducers: {
		startLoadingUsers(state) {
			state.isLoading = true;
		},

		hasError(state, action) {
			state.error = action.payload;
			state.isLoading = false;
		},

		getUsersSuccess(state, action) {
			state.users = action.payload;
			state.isLoading = false;
		},
	},
});

export default slice.reducer;

export function getUsers() {
	return async () => {
		try {
			dispatch(slice.actions.startLoadingUsers());
			const response = await db.collection("users").get();
			const users = response.docs.map((doc) => doc.data());
			const studiesResponse = await db.collection("studies").get();
			const studies = studiesResponse.docs.reduce((acc:any, doc:any) => {
			  acc[doc.id] = doc.ref.collection('data').get();
			  return acc;
			}, {});
	  
			const newUsersArray = await Promise.all(users.map(async (user) => {
			  const studyDataSnapshot = await studies[user.uid];
			  const studiesCount = studyDataSnapshot?.size;
			  return { ...user, studiesCount };
			}));
			dispatch(slice.actions.getUsersSuccess(newUsersArray));
		} catch (error) {
			throw error;
		}
	};
}
